import React from 'react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Flex, Box} from '@chakra-ui/react'
import TermsModal from './TermsModal'

const DirectDebitRequestModal = ({triggerLabel, triggerButtonVariant}) => {
  const {t} = useTranslation('onboarding')

  return (
    <TermsModal
      triggerButtonVariant={triggerButtonVariant}
      triggerLabel={
        triggerLabel ||
        t('onboarding:ZeptoDirectDebitRequestModal.triggerLabel')
      }
      modalTitle={t('onboarding:ZeptoDirectDebitRequestModal.title')}
    >
      <Flex gap="md" direction="column">
        <Box>
          You request and authorise Zepto Payments Pty Ltd (User ID #454146,
          492448, 500298, 507533, 518403, 518404, 531942, 543948, 543950,
          543949, 543954, 543947, 543955, 543956, 543957, 543958, 543962,
          600993, 600994, 600995, 600996, 600997, 600998, 600999, 601001,
          601002, 601003, 601004, 601005, 601006, 601007, 601008, 612056,
          612057, 613600, 613601, 613602, 613603, 613604, 613605, 613606,
          613607, 613608, 613609) (&quot;Zepto&quot;) on behalf of the Payment
          Initiator with whom you have a direct debit agreement, to arrange
          through its own financial institution, to debit from your nominated
          account any amount the Payment Initiator has deemed payable by you.
        </Box>

        <Box>
          This debit or charge will be made through the Bulk Electronic Clearing
          System (BECS) from your account held at the financial institution you
          have nominated and will be subject to the terms and conditions of the
          Direct Debit Request Service Agreement.
        </Box>

        <Box>
          Zepto Payments does not accept any liability for the provision,
          merchantable quality or fitness for purpose of the underlying goods or
          services provided to the User by the Payment Initiator and/or merchant
          and therefore the User holds Zepto Payments harmless for any claim
          that may arise from the non-provision of services by the Payment
          Initiator and/or merchant or any other claim that may be made against
          the Payment Initiator and/or merchant under Consumer Law.
        </Box>
      </Flex>
    </TermsModal>
  )
}

DirectDebitRequestModal.defaultProps = {
  triggerLabel: undefined,
  triggerButtonVariant: 'primary',
}

DirectDebitRequestModal.propTypes = {
  triggerLabel: PropTypes.string,
  triggerButtonVariant: PropTypes.string,
}

export default DirectDebitRequestModal
